import _ from 'lodash';

import { createSetPropMutation } from '@/store/utils';
import * as types from '@/store/newProject/mutationTypes';
import { emptyProject, initNewProjectNavigation } from '@/constants/projects';

export default {
  [types.SET_NEW_PROJECT]: createSetPropMutation('storedNewProject', _.cloneDeep(emptyProject)),

  [types.SET_NEW_PROJECT_NAVIGATION]: createSetPropMutation('storedNewProjectNavigation',
    _.cloneDeep(initNewProjectNavigation)),
};
